export default function AppEntry() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="bg-gradient-to-br from-primary-500 via-primary-600 to-accent-600 rounded-2xl overflow-hidden">
          <div className="flex flex-col lg:flex-row items-center">
            <div className="flex-1 p-8 md:p-12 lg:p-14 text-center lg:text-left">
              <span className="inline-block px-3 py-1 text-xs font-semibold bg-background-50/20 text-background-50 rounded-full mb-4">
                官方推荐
              </span>
              <h2 className="font-heading font-bold text-2xl md:text-3xl text-background-50 mb-4">
                每日大赛APP官方下载
              </h2>
              <p className="text-sm text-background-50/80 leading-relaxed mb-6 max-w-md mx-auto lg:mx-0">
                支持iOS与Android双平台，提供更流畅的每日大赛移动端体验。随时随地查看赛事动态，第一时间获取最新入口通知。
              </p>

              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 mb-6">
                <div className="flex items-center gap-3 bg-background-50/10 rounded-xl px-4 py-3">
                  <i className="ri-apple-fill text-2xl text-background-50"></i>
                  <div className="text-left">
                    <div className="text-[10px] text-background-50/60">iOS版本</div>
                    <div className="text-sm font-semibold text-background-50">v3.2.1</div>
                  </div>
                </div>
                <div className="flex items-center gap-3 bg-background-50/10 rounded-xl px-4 py-3">
                  <i className="ri-android-fill text-2xl text-background-50"></i>
                  <div className="text-left">
                    <div className="text-[10px] text-background-50/60">Android版本</div>
                    <div className="text-sm font-semibold text-background-50">v4.1.0</div>
                  </div>
                </div>
              </div>

              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                <a
                  href="#app"
                  className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-3 bg-background-50 text-primary-600 font-semibold rounded-lg hover:bg-background-100 transition-colors text-sm"
                >
                  <i className="ri-download-cloud-2-line"></i>
                  立即下载
                </a>
                <a
                  href="#faq"
                  className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-3 bg-background-50/10 text-background-50 font-medium rounded-lg hover:bg-background-50/20 transition-colors text-sm"
                >
                  <i className="ri-question-line"></i>
                  安装帮助
                </a>
              </div>
            </div>

            <div className="flex-1 w-full flex justify-center p-6 md:p-10">
              <div className="relative w-full max-w-[340px] aspect-[9/16] rounded-2xl overflow-hidden bg-background-50/10 shadow-2xl">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20smartphone%20mockup%20displaying%20a%20modern%20mobile%20app%20interface%20with%20vibrant%20contest%20and%20competition%20theme%2C%20colorful%20cards%20and%20leaderboard%20design%2C%20clean%20white%20phone%20frame%2C%20placed%20on%20a%20warm%20gradient%20background%2C%20professional%20app%20store%20style%20presentation%2C%20soft%20lighting%2C%20premium%20product%20photography&width=680&height=1210&seq=app-mockup-01&orientation=portrait"
                  alt="每日大赛APP官方下载 - iOS与Android双平台支持"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}